import * as React from 'react';
import { useSelector } from 'react-redux';

import { ReviewsMiniWidget } from 'shared/components/ReviewsMiniWidget';
import { selectRatingDetails } from 'shared/selectors/dailyrentData/selectRatingDetails';
import { selectRatingSummary } from 'shared/selectors/dailyrentData/selectRatingSummary';

export function ReviewsMiniWidgetContainer() {
  const ratingSummary = useSelector(selectRatingSummary);
  const ratingDetails = useSelector(selectRatingDetails);

  const onReviewsClick = React.useCallback(() => {
    if (!ratingDetails?.viewAllReviewsButtonUrl) {
      return;
    }

    window.open(ratingDetails?.viewAllReviewsButtonUrl);
  }, [ratingDetails?.viewAllReviewsButtonUrl]);

  return (
    <ReviewsMiniWidget
      rating={ratingSummary?.ratingValue}
      reviewsCount={ratingSummary?.reviewCount || undefined}
      onClick={onReviewsClick}
    />
  );
}
